import script from "./WelcomePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomePanel.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__